import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AdminLayout from "../../layouts/AdminLayout";
import api, { API_BASE_URL, fetchData } from "../../api/api";
import { AuthContext } from "../../context/AuthContext";
import Spinner from "../../components/common/Spinner";
import { decryptData, encryptData } from "../../utils/encryptDecrypt";
import { toast } from "react-toastify";
import { CONSTANT_REDIRECT_TIME } from "../../constant/common";
import { formatDateForView } from "../../utils/formateDate";


const AdminEnquiriesListPage = () => {

	const { practices_id } = useParams();

	const decrypted_practices_id = decryptData(practices_id);

	const didFetch = useRef(false);
	const [isLoading, setIsLoading] = useState(false);

	const [enquiriesList, setEnquiriesList] = useState([]);

	const [isDelete, setIsDelete] = useState(false);

	const [selectedEnquiries, setSelectedEnquiries] = useState(null);

	const [currentPage, setCurrentPage] = useState(1);

	const getEnquiries = async () => {
		if (decrypted_practices_id) {
			setIsLoading(true);
			try {
				const data = await fetchData('/get-enquiries', {
					fk_practices_id: decrypted_practices_id
				});
				setEnquiriesList(data);
				setCurrentPage(1);
			} catch (error) {
				console.error("Error fetching data:", error);
			} finally {
				setIsLoading(false);
			}
		}
	};


	useEffect(() => {
		if (!didFetch.current) {
			getEnquiries();
			didFetch.current = true;
		}
	}, []);

	const itemsPerPage = 10;

	const totalPages = Math.ceil(enquiriesList.length / itemsPerPage);

	const paginatedData = enquiriesList?.length > 0 ? enquiriesList.slice(
		(currentPage - 1) * itemsPerPage,
		currentPage * itemsPerPage
	) : [];

	const handlePageChange = (newPage) => {
		if (newPage > 0 && newPage <= totalPages) {
			setCurrentPage(newPage);
		}
	};

	const handleDelete = async () => {

		const payload = {
			practices_enquiries_id: selectedEnquiries?.practices_enquiries_id
		};

		try {
			const response = await api.post("delete-enquiries", payload);

			if (response?.data?.status === true) {
				toast.success(response.data?.message);

				setTimeout(() => {
					getEnquiries();
				}, CONSTANT_REDIRECT_TIME);


			} else {
				toast.error(response?.data?.message || "Failed to delete.");
				return null;
			}
		} catch (error) {
			console.error("Error delete :", error);
			toast.error("Something went wrong. Please try again.");
			return null;
		}

		setSelectedEnquiries(null);
		setIsDelete(false);
	}

	if (isLoading) {
		return (<Spinner adminLayout={true} />);
	}

	return (
		<>
			<AdminLayout>

				<main>
					<div className="px-4 py-4 sm:px-8 sm:py-6 md:px-12 md:py-7 flex justify-between gap-4 items-center">
						<h1 className="font-semibold text-lg sm:text-2xl">Enquiries</h1>
					</div>

					<div className="overflow-x-auto">
						<table className="w-full">
							<thead className="bg-lightblue">
								<tr>
									<th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-44">Name</th>
									<th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start">Email</th>
									<th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start">Phone Number</th>
									<th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-64">Message</th>
									<th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start">Action</th>
								</tr>
							</thead>
							<tbody>

								{paginatedData?.length > 0 ? paginatedData?.map((item, index) => (
									<tr
										key={index}
										className="border-b-2 border-solid border-[#dfdfdf]">
										<td className="py-2 px-1.5 sm:py-4 sm:px-3 text-start">
											{item?.name}
										</td>
										<td className="py-2 px-1.5 sm:py-4 sm:px-3 text-start">
											{item?.email}
										</td>
										<td className="py-2 px-1.5 sm:py-4 sm:px-3 text-start">
											{item?.phone}
										</td>
										<td className="py-2 px-1.5 sm:py-4 sm:px-3 text-start">
											<div className="message-container">
												<p className="text-dark text-base  truncate whitespace-normal overflow-hidden h-[4.5rem] max-w-[400px] w-full message-content">
													{item?.message}
												</p>
											</div>
										</td>
										<td className="py-2 px-1.5 sm:py-4 sm:px-3">
											<div className="rounded-full shadow-xs bg-blue max-w-[100px] w-full" role="group">
												<button
													onClick={() => {
														setIsDelete(true)
														setSelectedEnquiries(item)
													}}
													type="button" className="py-2 text-sm font-medium bg-transparent rounded-e-full w-full text-center flex items-center justify-center text-white">
													<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z" fill="white"></path>
													</svg>
												</button>
											</div>
											{/* <div className="flex rounded-full shadow-xs bg-blue max-w-[120px] w-full" role="group">
												<button type="button" className="pl-6 pr-3 py-2 text-sm font-medium  bg-transparent rounded-s-full replaybtn">
													<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M2.72662 2.86504L2.96662 1.36504C2.98717 1.23243 2.9542 1.09709 2.87497 0.988786C2.79574 0.880484 2.67672 0.808093 2.54412 0.787539C2.41151 0.766984 2.27617 0.79995 2.16786 0.879184C2.05956 0.958419 1.98717 1.07743 1.96662 1.21004C1.51662 4.07004 1.36662 4.36004 1.65662 4.62504C1.81162 4.76504 1.90162 4.74504 4.87662 5.21504C5.00922 5.23559 5.14457 5.20263 5.25287 5.12339C5.36117 5.04416 5.43356 4.92515 5.45412 4.79254C5.47467 4.65993 5.4417 4.52459 5.36247 4.41629C5.28324 4.30798 5.16422 4.23559 5.03162 4.21504L3.03162 3.90004C10.0916 -2.55496 21.5016 2.46004 21.5016 12C21.5021 13.7698 21.0756 15.5136 20.2582 17.0833C19.4409 18.653 18.2568 20.0024 16.8066 21.0168C15.3564 22.0312 13.6829 22.6807 11.928 22.9102C10.1732 23.1397 8.38891 22.9424 6.72662 22.335C6.60196 22.2893 6.46424 22.2949 6.34375 22.3507C6.22326 22.4065 6.12987 22.5079 6.08412 22.6325C6.03837 22.7572 6.04401 22.8949 6.0998 23.0154C6.15559 23.1359 6.25696 23.2293 6.38162 23.275C8.19517 23.938 10.1419 24.1535 12.0566 23.9033C13.9712 23.6531 15.7972 22.9446 17.3795 21.8378C18.9618 20.7311 20.2536 19.2589 21.1453 17.5462C22.0371 15.8335 22.5023 13.931 22.5016 12C22.5016 1.82004 10.5016 -3.74996 2.72662 2.86504Z" fill="white"></path>
														<path d="M17.5 16.5V8.5C17.5 8.10218 17.342 7.72064 17.0607 7.43934C16.7794 7.15804 16.3978 7 16 7H5C4.60218 7 4.22064 7.15804 3.93934 7.43934C3.65804 7.72064 3.5 8.10218 3.5 8.5V19.5L6 18H16C16.3978 18 16.7794 17.842 17.0607 17.5607C17.342 17.2794 17.5 16.8978 17.5 16.5ZM12.5 15.5H6C5.86739 15.5 5.74021 15.4473 5.64645 15.3536C5.55268 15.2598 5.5 15.1326 5.5 15C5.5 14.8674 5.55268 14.7402 5.64645 14.6464C5.74021 14.5527 5.86739 14.5 6 14.5H12.5C12.6326 14.5 12.7598 14.5527 12.8536 14.6464C12.9473 14.7402 13 14.8674 13 15C13 15.1326 12.9473 15.2598 12.8536 15.3536C12.7598 15.4473 12.6326 15.5 12.5 15.5ZM15 13H6C5.86739 13 5.74021 12.9473 5.64645 12.8536C5.55268 12.7598 5.5 12.6326 5.5 12.5C5.5 12.3674 5.55268 12.2402 5.64645 12.1464C5.74021 12.0527 5.86739 12 6 12H15C15.1326 12 15.2598 12.0527 15.3536 12.1464C15.4473 12.2402 15.5 12.3674 15.5 12.5C15.5 12.6326 15.4473 12.7598 15.3536 12.8536C15.2598 12.9473 15.1326 13 15 13ZM15 10.5H6C5.86739 10.5 5.74021 10.4473 5.64645 10.3536C5.55268 10.2598 5.5 10.1326 5.5 10C5.5 9.86739 5.55268 9.74021 5.64645 9.64645C5.74021 9.55268 5.86739 9.5 6 9.5H15C15.1326 9.5 15.2598 9.55268 15.3536 9.64645C15.4473 9.74021 15.5 9.86739 15.5 10C15.5 10.1326 15.4473 10.2598 15.3536 10.3536C15.2598 10.4473 15.1326 10.5 15 10.5Z" fill="white"></path>
													</svg>
												</button>
												<button
													onClick={() => {
														setIsDelete(true)
														setSelectedEnquiries(item)
													}}
													type="button" className="pl-3 pr-6 py-2 text-sm font-medium  bg-transparent rounded-e-full deletebtn">
													<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z" fill="white"></path>
													</svg>
												</button>
											</div> */}
										</td>

									</tr>
								)) : (
									<tr>
										<td colSpan={6} className="text-center py-2 px-1.5 sm:py-4 sm:px-3 border-y-2 border-solid border-[#dfdfdf]">No Enquiries Found</td>
									</tr>
								)}
							</tbody>
						</table>

					</div>

					{paginatedData?.length > 0 && (
						<div className="px-3 py-3">
							<ul className="flex items-center -space-x-px h-10 text-base justify-end">
								{/* Previous Button */}
								<li>
									<button
										onClick={() => handlePageChange(currentPage - 1)}
										disabled={currentPage === 1}
										className={`flex items-center justify-center px-4 h-10 ms-0 leading-tight border border-e-0 rounded-s-lg border-[#73aeff] 
          ${currentPage === 1 ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
									>
										<svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
											<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"></path>
										</svg>
									</button>
								</li>

								{/* Dynamic Pagination Logic */}
								{Array.from({ length: totalPages }, (_, i) => i + 1)
									.filter((page) => {
										return (
											page === 1 ||
											page === totalPages ||
											(page >= currentPage - 1 && page <= currentPage + 1)
										);
									})
									.reduce((acc, page, index, arr) => {
										if (index > 0 && page !== arr[index - 1] + 1) {
											acc.push("...");
										}
										acc.push(page);
										return acc;
									}, [])
									.map((page, index) => (
										<li key={index}>
											{page === "..." ? (
												<span className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] bg-gray-200 text-blue`}>...</span>
											) : (
												<button
													onClick={() => handlePageChange(page)}
													className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] 
                ${currentPage === page ? "bg-white text-blue" : "bg-gray-200 text-blue hover:bg-gray-100"}`}
												>
													{page}
												</button>
											)}
										</li>
									))}

								{/* Next Button */}
								<li>
									<button
										onClick={() => handlePageChange(currentPage + 1)}
										disabled={currentPage === totalPages}
										className={`flex items-center justify-center px-4 h-10 leading-tight border rounded-e-lg border-[#73aeff] 
          ${currentPage === totalPages ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
									>
										<svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
											<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"></path>
										</svg>
									</button>
								</li>
							</ul>
						</div>
					)}


					<div id="deletepopup" className={`fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] justify-center items-center px-3 ${isDelete ? 'flex' : 'hidden'}`}>
						<div className="max-w-[630px] w-full mx-auto bg-white rounded-xl sm:rounded-2xl px-3 py-6 sm:py-10 sm:px-10 lg:px-20 innercard">
							<div className="max-w-[312px] w-full flex justify-center items-center gap-6 flex-col mx-auto">
								<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M36 66C19.4314 66 6 52.5684 6 36C6 19.4314 19.4314 6 36 6C52.5684 6 66 19.4314 66 36C66 52.5684 52.5684 66 36 66ZM36 60C49.2549 60 60 49.2549 60 36C60 22.7452 49.2549 12 36 12C22.7452 12 12 22.7452 12 36C12 49.2549 22.7452 60 36 60ZM36 31.7574L44.4852 23.2721L48.7278 27.5147L40.2426 36L48.7278 44.4852L44.4852 48.7278L36 40.2426L27.5147 48.7278L23.2721 44.4852L31.7574 36L23.2721 27.5147L27.5147 23.2721L36 31.7574Z" fill="#FF5252" />
								</svg>
								<h4 className="text-center font-bold text-xl mg:text-2xl text-blue">Are you sure! <br />you want to Delete?</h4>
								<div className="flex justify-between gap-3 w-full">
									<button
										type="button"
										onClick={() => {
											setIsDelete(false)
											setSelectedEnquiries(null)
										}}
										className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-dark cancelbtn">Cancel</button>
									<button
										type="button"
										onClick={handleDelete}
										className="bg-blue text-center text-white text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-blue deletebtn">Delete</button>
								</div>
							</div>
						</div>
					</div>
				</main>
			</AdminLayout>
		</>)
}

export default AdminEnquiriesListPage